import React, { useEffect } from "react";
import { LayoutContainer } from "./styled-components";
import { LayoutSituationProps } from "./types";
import {
  HeaderContainer,
  RightContainer,
  LeftContainer,
  UrgencyContainer,
} from "./styled-components";
import ContactCard from "../contactCard";
import Stepper from "../stepper";
import PreviousButton from "../PreviousButton";
import UrgencyButton from "../urgencyButton";
import UrgencyBloc from "../urgencyBloc";
import { useLocation } from "react-router-dom";

export const LayoutSituation = ({
  children,
  withUrgencyNumber,
  steps,
  activeStep,
  onPrevious,
}: LayoutSituationProps) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <LayoutContainer>
      <HeaderContainer>
        <LeftContainer>
          <PreviousButton onClick={onPrevious} />
          <Stepper steps={steps} activeStep={activeStep} />
        </LeftContainer>
        <RightContainer>
          {withUrgencyNumber && <UrgencyButton />}
        </RightContainer>
      </HeaderContainer>
      {children}

      <ContactCard
        text="Vous avez des questions ? Le Défenseur des droits vous écoute et
        vous aide gratuitement partout en France."
      />
      {withUrgencyNumber && (
        <UrgencyContainer>
          <UrgencyBloc />
        </UrgencyContainer>
      )}
    </LayoutContainer>
  );
};

export default LayoutSituation;
